export const menuFilterAction = (data,type)=> ({type,payload:data}) 